import { client } from '@atlassian/rovo-content-bridge-api';
var CONFLUENCE_EDITOR_CLIENT_ID_PREFIX = 'confluence-editor';
export var getConfluenceEditorClientId = function getConfluenceEditorClientId(contentId) {
  return client("".concat(CONFLUENCE_EDITOR_CLIENT_ID_PREFIX, "-").concat(contentId));
};